import React, { useState } from "react";
import "../../style/UserDetail.css";
import { getUserDetailsRequest } from "../../../redux/actionDispatcher/admin/userDetailDispatcher";
import { connect, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import dummyProfileImage from "./../../assets/image/dummy-profile-image.png"
import { dealerUrl, dealerLoginAsUrl, imageBaseUrls, webSiteUrl , impersonationTicketUrl } from "../../../constant/ApiUrls";
import moment from "moment";
import { addBumpSpotlightRequest } from "../../../redux/actionDispatcher/admin/dealerListingDispatcher";
import { toast } from "react-toastify";
import { ApiURLs } from "../../../constant/ApiUrls";
import { fetchData, postData, patchData } from "../../../services/api";

/* The country used to be the literal text "Isle of Man", because this admin was
   cloned from the Isle of Man one and nobody changed the word. On listit.ie it
   sat under an Irish county and an Irish phone number, which is how it was
   spotted. Users carry a country_code (IE for 237 of them), so read it. */
const COUNTRY_NAMES = {
  IE: "Ireland", GB: "United Kingdom", IM: "Isle of Man", GG: "Guernsey",
  JE: "Jersey", US: "United States", CA: "Canada", AU: "Australia",
  NZ: "New Zealand", ZA: "South Africa", PK: "Pakistan", IN: "India",
  DE: "Germany", FR: "France", ES: "Spain", PT: "Portugal", PL: "Poland",
  LT: "Lithuania", LV: "Latvia", RO: "Romania", BR: "Brazil", BJ: "Benin",
};
const countryOf = (u) =>
  (u && u.country) ||
  COUNTRY_NAMES[String((u && u.country_code) || "").toUpperCase()] ||
  "Ireland";


const VatVerifyButton = ({ vatNumber, vatVerified, userId, onVerified }) => {
  const [checking, setChecking] = React.useState(false);
  const [result, setResult] = React.useState(null);

  if (!vatNumber || vatNumber.trim() === '') {
    return <span style={{ color: '#888', fontSize: '13px' }}>No VAT number provided</span>;
  }

  const handleVerify = async () => {
    setChecking(true);
    try {
      const response = await fetchData(ApiURLs.VERIFY_VAT + '?vat_number=' + encodeURIComponent(vatNumber));
      if (response.status === 1) {
        setResult(response.data);
        if (response.data.valid) {
          await patchData(ApiURLs.USER_UPDATE + '/' + userId, { vat_verified: 1 });
          if (onVerified) onVerified(true);
        }
      }
    } catch (error) {
      console.error('VAT verify error:', error);
      setResult({ valid: false, error: true });
    } finally {
      setChecking(false);
    }
  };

  if (vatVerified === 1 && !result) {


    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
        {vatNumber}
        <span style={{ color: 'green', fontSize: '16px' }} title="VAT Verified">&#10004;</span>
      </span>
    );
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
      {vatNumber}
      {result ? (
        result.valid ? (
          <span style={{ color: 'green', fontSize: '13px', fontWeight: '600' }}>
            &#10004; Valid - {result.name}
          </span>
        ) : (
          <span style={{ color: 'red', fontSize: '13px', fontWeight: '600' }}>
            &#10008; Invalid
          </span>
        )
      ) : (
        <button
          onClick={handleVerify}
          disabled={checking}
          style={{
            padding: '3px 12px',
            backgroundColor: '#4f83df',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: checking ? 'not-allowed' : 'pointer',
            fontSize: '11px',
            opacity: checking ? 0.6 : 1
          }}
        >
          {checking ? 'Checking...' : 'Verify VAT'}
        </button>
      )}
    </span>
  );
};

const InternalNotes = ({ userId }) => {
  const [notes, setNotes] = React.useState([]);
  const [newNote, setNewNote] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [submitting, setSubmitting] = React.useState(false);

  const fetchNotes = async () => {
    try {
      const response = await fetchData(ApiURLs.INTERNAL_NOTES + '?user_id=' + userId);
      if (response.status === 1) {
        setNotes(response.data || []);
      }
    } catch (error) {
      console.error('Error fetching notes:', error);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchNotes();
  }, [userId]);

  const handleAddNote = async () => {
    if (!newNote.trim()) return;
    setSubmitting(true);
    try {
      const response = await postData({ user_id: parseInt(userId), note: newNote.trim() }, ApiURLs.INTERNAL_NOTES, false);
      if (response.status === 1) {
        setNotes([response.data, ...notes]);
        setNewNote('');
      }
    } catch (error) {
      console.error('Error adding note:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="section" style={{ marginTop: '20px' }}>
      <div className="user-header">
        <h3 style={{ display: 'inline' }}>Internal Notes</h3>
        <span style={{ fontSize: '12px', color: '#888', fontStyle: 'italic', marginLeft: '10px' }}>
          Visible to admins only
        </span>
      </div>
      <div style={{ marginBottom: '15px' }}>
        <textarea
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)}
          placeholder="Write an internal note..."
          rows={3}
          style={{
            width: '100%',
            padding: '10px',
            borderRadius: '6px',
            border: '1px solid #ddd',
            fontSize: '14px',
            resize: 'vertical',
            fontFamily: 'inherit'
          }}
        />
        <button
          onClick={handleAddNote}
          disabled={submitting || !newNote.trim()}
          style={{
            marginTop: '8px',
            padding: '8px 20px',
            backgroundColor: '#4f83df',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: submitting || !newNote.trim() ? 'not-allowed' : 'pointer',
            opacity: submitting || !newNote.trim() ? 0.6 : 1,
            fontSize: '13px'
          }}
        >
          {submitting ? 'Adding...' : 'Add Note'}
        </button>
      </div>
      {loading ? (
        <p style={{ color: '#888', fontSize: '13px' }}>Loading notes...</p>
      ) : notes.length === 0 ? (
        <p style={{ color: '#888', fontSize: '13px' }}>No internal notes yet.</p>
      ) : (
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {notes.map((note) => (
            <div
              key={note.id}
              style={{
                padding: '12px 15px',
                backgroundColor: '#f8f9fa',
                borderLeft: '4px solid #4f83df',
                borderRadius: '4px',
                marginBottom: '10px'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                <strong style={{ fontSize: '13px', color: '#333' }}>{note.admin_name}</strong>
                <span style={{ fontSize: '12px', color: '#888' }}>
                  {new Date(note.created_at).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                  {' '}
                  {new Date(note.created_at).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                </span>
              </div>
              <p style={{ margin: 0, fontSize: '14px', color: '#444', whiteSpace: 'pre-wrap' }}>
                {note.note}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const UserDetail = ({ userDetails, getUserDetailsRequest }) => {

  const dispatch = useDispatch();
  const [loadSpotlight, setLoadSpotlight] = useState(false);
  const [loadBump, setLoadBump] = useState(false);

  // const navigate = useNavigate();
  const { id } = useParams(); // Get the ID from the URL
  const userId = id.replace(":", "");
  console.log("User ID:", userId);
  // const dispatch = useDispatch();
  React.useEffect(() => {
    getUserDetailsRequest(userId); // Fetch users only once when the component loads
    // GET_OPENING_HOURS
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);








  const handleSubmit = async (type) => {
    if (type === 1) setLoadBump(true);
    if (type === 2) setLoadSpotlight(true);

    const data = {
      id: userDetails.usersDetails.id,
      type: type,
    };

    try {
      const success = await dispatch(addBumpSpotlightRequest(data)); // ✅ awaits thunk
      if (success) {
        toast.success(type === 1 ? "Bump added successfully!" : "Spotlight added successfully!");
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error("Error adding bump/spotlight:", error);
    } finally {
      if (type === 1) setLoadBump(false);
      if (type === 2) setLoadSpotlight(false);
    }
  };




  /*
    Open a customer's account safely.

    Until 07/10 this put base64 of the user's id in the address - 'MjM1MQ=='
    is just 2351 - and the endpoint that swapped it for a session had no
    authentication at all, so anyone could forge one for any customer.

    Now Super Admin asks the API for a one-time pass (that request carries the
    admin token, so only we can get one) and opens THAT. The pass dies in five
    minutes and works once.
  */
  const openAsUser = async (id, baseUrl) => {
    const res = await postData({ user_id: id }, impersonationTicketUrl, false);
    const ticket = res && res.data && res.data.ticket;
    if (!ticket) return;            // postData has already shown the error
    window.open(`${baseUrl}loginasuser/${ticket}`, '_blank');
  };

  return (
    userDetails.loading ?
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-4 mx-auto" style={{ backgroundColor: 'var(--primary-color)' }}></div>
      </div>
      :
      userDetails.usersDetails.vendor_type === 'normal' ? <div className="container">
        {/* User Header */}
        <div className="user-card">
          <div className="user-header" style={{ justifyContent: "center" }}>
            <div className="user-info" style={{ textAlign: "center" }}>

              <div className="user-details" style={{ textAlign: "center" }}>
                <img src={userDetails.usersDetails.image ? `${imageBaseUrls(userDetails.usersDetails.image)}` : dummyProfileImage} alt="Profile" className="user-avatar" style={{ height: "100px", width: "100px", marginBottom: "10px" }} />
                <h2 style={{ marginBottom: "6px" }}>{userDetails.usersDetails.name}</h2>
                {/* The account number the customer quotes on the phone. */}
                <div style={{ marginBottom: "10px", fontFamily: "monospace", fontSize: "15px", letterSpacing: "1px", color: "#444" }}>
                  Account No: <strong>{userDetails.usersDetails.account_number || "--"}</strong>
                </div>
                <div>
                  <div style={{ padding: "2px 10px", display: "inline-block", backgroundColor: userDetails.usersDetails.status === 1 ? "green" : "red", borderRadius: "10px" }}>

                    <span
                      style={{
                        color: "white",
                        fontWeight: "500",
                        fontSize: "10px",
                      }}
                    >
                      {userDetails.usersDetails.status === 1 ? "Active" : "Blocked"}
                    </span>

                  </div>
                  <div>
                    <button onClick={() => {
                      openAsUser(userId, webSiteUrl);

                    }
                    } className="btn btn-primary mt-2">Login as <strong>{userDetails.usersDetails.name}</strong></button>
                  </div>
                </div>


              </div>

            </div>

          </div>
        </div>



        {/* Address */}
        <div className="section">
          <div className="user-header">
            <h3>Address</h3>

          </div>
          <div className="info-grid">
            <div className="info-item"><span>Location:</span> {userDetails.usersDetails?.location_name === null ? 'Not Filled' : userDetails.usersDetails?.location_name} </div>

            <div className="info-item"><span>Country:</span> {countryOf(userDetails.usersDetails)}</div>
          </div>
        </div>

        <div className="section">
          <div className="user-header">
            <h3>Other Details</h3>

          </div>

          <div className="info-grid">
            <div className="info-item"><span>Verified Email:</span>&nbsp;{userDetails.usersDetails.email} {userDetails.usersDetails.email_verified === 0 ? <p></p> : <i className="fas fa-check-circle" style={{ color: "var(--primary-color)", fontSize: "12px" }}></i>}</div>

            <div className="info-item"><span>Verified Number:</span>&nbsp;{userDetails.usersDetails.flag ? "+" : ""}{userDetails.usersDetails.flag} {userDetails.usersDetails.number} {userDetails.usersDetails.otp_verified === 0 ? <p></p> : <i className="fas fa-check-circle" style={{ color: "var(--primary-color)", fontSize: "12px" }}></i>}</div>
          </div>
          <div className="info-grid">
            <div className="info-item"><span>Join Date:</span> {moment(userDetails.usersDetails?.created_at).format("DD/MM/YYYY HH:mm:ss")}</div>

            <div className="info-item"><span>Hours Logged In:</span> {userDetails.usersDetails?.total_hours_logged} hrs</div>
          </div>
          <div className="info-grid">
            <div className="info-item"><span>Ads Live:</span> {userDetails.usersDetails?.ads_count || 0}</div>

            <div className="info-item"><span>Save Ads:</span> {userDetails.usersDetails?.saved_ad_count || 0}</div>
          </div>
          <div className="info-grid">
            <div className="info-item"><span>Ads Historically:</span> {userDetails.usersDetails?.total_ads_count || 0}</div>


          </div>
        </div>
        <InternalNotes userId={userId} />
      </div>
        :
        userDetails.usersDetails.vendor_type === 'dealer' ? (
          <div className="container dealer-profile">

            {/* Dealer Header */}
            <div className="dealer-profile card shadow-lg p-4">
              <div className="row g-4 align-items-center">
                {/* Left Side - Dealer Image */}
                <div className="col-md-4 text-center">
                  <div className="dealer-avatar-wrapper">
                    <img
                      src={userDetails.usersDetails.image ? `${imageBaseUrls(userDetails.usersDetails.image)}` : dummyProfileImage}
                      alt="Dealer"
                      className="dealer-avatar-lg"
                    />
                    <span
                      className={`status-badge ${userDetails.usersDetails.status === 1 ? "active" : "blocked"
                        }`}
                    >
                      {userDetails.usersDetails.status === 1 ? "Active" : "Blocked"}
                    </span>
                  </div>
                </div>

                {/* Right Side - Dealer Info */}
                <div className="col-md-8">

                  <div>
                    <h2 className="dealer-name mb-1">{userDetails.usersDetails.name}</h2>
                    <h4 className="dealer-business text-primary mb-2">
                      {userDetails.usersDetails.business_name}
                    </h4>
                    {/* The account number the dealer quotes on the phone. */}
                    <div className="mb-3" style={{ fontFamily: "monospace", fontSize: "15px", letterSpacing: "1px", color: "#444" }}>
                      Account No: <strong>{userDetails.usersDetails.account_number || "--"}</strong>
                    </div>



                    <button onClick={() => {
                      openAsUser(userId, dealerLoginAsUrl);

                    }
                    } className="btn btn-primary mt-2">Login as <strong>{userDetails.usersDetails.name}</strong>
                    </button>




                    <button
                      onClick={() => handleSubmit(2)}
                      className="btn btn-primary mt-2"
                      style={{ marginLeft: "10px", minWidth: "140px" }}
                      disabled={loadSpotlight}
                    >
                      {loadSpotlight ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          &nbsp;Adding...
                        </>
                      ) : (
                        "Add Spotlight"
                      )}
                    </button>

                    {/* Add Bump Button */}
                    <button
                      onClick={() => handleSubmit(1)}
                      className="btn btn-primary mt-2"
                      style={{ marginLeft: "10px", minWidth: "140px" }}
                      disabled={loadBump}
                    >
                      {loadBump ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          &nbsp;Adding...
                        </>
                      ) : (
                        "Add Bump"
                      )}
                    </button>
                  </div>


                  <div className="info-grid">
                    <div className="info-item"><span>Email:</span> {userDetails.usersDetails.email}</div>
                    <div className="info-item"><span>Phone:</span> +{userDetails.usersDetails.flag} {userDetails.usersDetails.number}</div>
                    <div className="info-item"><span>Website:</span> {userDetails.usersDetails.website || "Not Provided"}</div>
                    <div className="info-item"><span>Address:</span> {userDetails.usersDetails.business_address || "Not Provided"}</div>
                    <div className="info-item"><span>Location:</span> {userDetails.usersDetails?.location_name || "Not Filled"}</div>
                    <div className="info-item"><span>About:</span> {userDetails.usersDetails.about || "Not Provided"}</div>
                    <div className="info-item">
                      <span>VAT Number:</span>{" "}
                      <VatVerifyButton
                        vatNumber={userDetails.usersDetails.business_vat}
                        vatVerified={userDetails.usersDetails.vat_verified}
                        userId={userId}
                      />
                    </div>

                    {userDetails.usersDetails.new_tier_id && <div className="info-item"><span>Tier:</span> {userDetails.usersDetails?.tier_name || ""}</div>
                    }


                    {userDetails.usersDetails.new_tier_id && (
                      <div className="info-item">
                        <span>Tier Expiry:</span>{" "}
                        {(() => {
                          const expiry = userDetails.usersDetails.tier_expiry;

                          if (!expiry) return "";

                          const expiryDate = new Date(expiry);
                          const now = new Date();

                          // Format date as DD-MM-YYYY
                          const formattedDate = expiryDate.toLocaleDateString("en-GB");

                          const isExpired = expiryDate < now;

                          return (
                            <span style={{ color: isExpired ? "red" : "inherit" }}>
                              {isExpired ? `Expired on ${formattedDate}` : formattedDate}
                            </span>
                          );
                        })()}
                      </div>
                    )}




                    <div className="info-item"><span>Created By:</span> {userDetails.usersDetails?.admin_name || "Not Filled"}</div>
                    <div className="info-item"><span>Updated By:</span> {userDetails.usersDetails?.updated_admin_name || "Not Provided"}</div>

                    <div className="info-item">
                      <span>Created At:</span> {userDetails.usersDetails?.created_at
                        ? new Date(userDetails.usersDetails.created_at).toLocaleDateString("en-GB", {
                          day: "2-digit", month: "2-digit", year: "numeric"
                        })
                        : "Not Filled"}
                    </div>

                    <div className="info-item">
                      <span>Updated At:</span> {userDetails.usersDetails?.updated_at
                        ? new Date(userDetails.usersDetails.updated_at).toLocaleDateString("en-GB", {
                          day: "2-digit", month: "2-digit", year: "numeric"
                        })
                        : "Not Provided"}
                    </div>

                  </div>
                </div>
              </div>
              {/* <h3 className="section-title">Statistics</h3> */}
              <div className="stats-grid mt-2">
                <div className="stat-card">
                  <h4>{userDetails.usersDetails?.ads_count || 0}</h4>
                  <p>Ads Live</p>
                </div>
                <div className="stat-card">
                  <h4>{userDetails.usersDetails?.saved_ad_count || 0}</h4>
                  <p>Saved Ads</p>
                </div>
                <div className="stat-card">
                  <h4>{userDetails.usersDetails?.recent_ads_count || 0}</h4>
                  <p>Recent Ads</p>
                </div>
                <div className="stat-card">
                  <h4>{moment(userDetails.usersDetails?.created_at).format("DD/MM/YYYY")}</h4>
                  <p>Joined On</p>
                </div>
              </div>
              {(userDetails.usersDetails.opening_hours && <>
                <h3 className="section-title mt-4">Opening Hours</h3>
                <div className="hours-grid">
                  {userDetails.usersDetails.opening_hours.map((hour, index) => (
                    <div key={index} className="hours-item">
                      <strong>{hour.day_of_week}:</strong>{" "}
                      {hour.is_closed ? (
                        <span className="closed">Closed</span>
                      ) : (
                        `${hour.open_time} - ${hour.close_time}`
                      )}
                    </div>
                  ))}
                </div>

              </>)}

            </div>
            <InternalNotes userId={userId} />
          </div>
        )

          :
          <div>

          </div>
  );
};



//Getting the state from the store
const mapStateToProps = (state) => {
  return {
    userDetails: state.userDetails,
  };
};

//passing the userData in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    getUserDetailsRequest: (data, navigate) => dispatch(getUserDetailsRequest(data, navigate)),
  };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);
